export default __webpack_public_path__ + "static/media/favicon.ff6028a7.png";